<template>
  <div class="file-upload-container">

  <h5 v-if="complete" class="file-upload-complete"><img :src="st_checkimg" width="48" height="48"></h5>
  <label v-if="!complete && !fileselezionato && !showimage" :for="fileuploadid" class="custom_upload_label" @click="triggerUpload">
      {{ label }}
    </label>
    <label v-if="!complete && !fileselezionato && showimage" :for="fileuploadid" class="custom_upload_label" @click="triggerUpload">
      <img :src="st_uploadimg" width="32" height="32">
    </label>

  <input :id="fileuploadid" class="custom_upload_control" v-if="!complete && uploadPercentage === 0" ref="file" v-on:change="handleFileUploadM()" type="file">
  <div class="loader" v-if="started"></div>
  <p v-if="!complete && started && !error">{{ uploadPercentage }} / 100 %</p>
    <p v-if="!complete && fileselezionato && !error">{{ $t("message.fup_dimensione") }} : {{ humanFileSize(dimensione) }}</p>
    <div v-if="avvisodimensione">
      <p>{{ $t("message.fup_warningdimensione") }}</p>
      <button @click="upload" v-if="avvisodimensione && !complete">{{ $t("message.fup_conferma") }}</button>
      <button @click="annullaSelezione" v-if="avvisodimensione && !complete">{{ $t("message.fup_annulla") }}</button>
    </div>

  <div v-if="error" class="file-upload-error">
    <img :src="st_uperror" width="32" height="32" v-if="error">
    <p v-if="error">{{ $t("message.fup_uploaderror") }}</p>
  </div>
  </div>
</template>

<script>

import { ref }from "vue";
import axios from "axios";
import { humanFileSize } from "@/lib/dimensionefile";

export default {
  name: "FileUploadNew",
  components: {

  },
  setup() {
    const file = ref(null)


    return {
      file
    }
  },
  props: {
    ticketref: {
      type: String,
    },
    psgref: {
      type: String,
    },
    filetype: {
      type: Number,
    },
    modelValue: {
      type: String,
      default: null,
    },
    autoupload:{
      type: Boolean,
      default: false,
    },
    fileuploadid:{
      type:String,
      default: "fileupload1"
    },
    label:{
      type:String,
      default : 'Carica file'
    },
    showimage:{
      type:Boolean,
      default:false
    }
  },
    data(){
      return {
        perc :0,
        complete : false,
        cfile : null,
        uploadPercentage: 0,
        chunks: [],
        dimensione: 0,
        originalName: null,
        type : null,
        uploaded: 0,
        avvisodimensione : false,
        random: 0,
        error: false,
        started: false,
        fileselezionato : false,
        st_checkimg : require('../assets/check.svg'),
        st_uploadimg : require('../assets/upload.svg'),
        st_uploadimg2 : require('../assets/upload2.svg'),
        st_uperror : require('../assets/error.svg'),
      }
    },
  methods:{
    triggerUpload(){
     // document.getElementById(this.fileuploadid).click();
    },
    async handleFileUploadM() {
      this.fileselezionato = true;
      this.createChunks();
      this.dimensione = this.$refs.file.files[0].size;
      this.originalName = this.$refs.file.files[0].name;
      this.type = this.$refs.file.files[0].type;
      this.random = Math.floor(Math.random() * 9000) + 1000;
      if(this.dimensione > 4096000){
        this.avvisodimensione = true;
      }else {
        this.avvisodimensione = false;
        this.upload();
      }
    },
    createChunks() {
      this.chunks = [];
      let size = 819200, chunks = Math.ceil(this.$refs.file.files[0].size / size);

      for (let i = 0; i < chunks; i++) {
        this.chunks.push(this.$refs.file.files[0].slice(
            i * size, Math.min(i * size + size, this.$refs.file.files[0].size), this.$refs.file.files[0].type
        ));
      }
    },
    annullaSelezione(){
      this.fileselezionato = false;
      this.avvisodimensione = false;
      this.error = false;
      this.chunks = [];
      document.getElementById(this.fileuploadid).value = null;

    },
    upload(){
      let me = this;
      me.avvisodimensione = false;
      let formdata = new FormData();
      formdata.append('ticketref',this.ticketref);
      formdata.append('psgref',this.psgref);
      formdata.append('filetype',this.filetype);
      formdata.append('file',this.chunks[0],me.originalName +"." + me.random+".part");
      formdata.set('last', this.chunks.length === 1);
      me.started = true;
      if(me.chunks.length === 1){
        formdata.set('random',me.random);
      }
      axios.post(process.env.VUE_APP_API_BASE_URL+process.env.VUE_APP_URL_FILEUPLOAD,formdata,{headers: {
          'Content-Type': 'application/octet-stream'
        },
        onUploadProgress: function( progressEvent ) {
          this.uploaded = this.uploaded += progressEvent.loaded;
          this.uploadPercentage = parseInt( Math.round( ( this.uploaded / this.dimensione ) * 100 ) );
        }.bind(this)
      }).then((response)=>{
        console.log(response);
        if(response.data.STATUS === "OK") {
          me.chunks.shift();
          if(me.chunks.length < 1) {
            me.$emit('uploadcomplete', me.originalName);
            me.complete = true;
            me.started = false;
            me.uploadPercentage = 100;
          }else me.upload();
        }else {
          me.error = true;
          me.started = false;
        }
      }).catch((err)=>{
        console.log(err);
      })
    },
    humanFileSize : humanFileSize
  },
  watch:{
    uploadPercentage:function(newvalue){
      console.log(newvalue);

    }

  }

  }
</script>

<style scoped>
  .file-upload-color  {
    color: #2b4463;
  }

  .file-upload-complete {
    color: #94e676;
  }

  .file-upload-error {
    color : #cf0000;
  }


  .loader,
  .loader:after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }
  .loader {
    margin: 60px auto;
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: 1.1em solid rgba(17,43,232, 0.2);
    border-right: 1.1em solid rgba(17,43,232, 0.2);
    border-bottom: 1.1em solid rgba(17,43,232, 0.2);
    border-left: 1.1em solid #2b4463;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .custom_upload_control {
    opacity: 0;
    height: 0;
    width: 0;
  }

  .custom_upload_label {
    display: block;
    justify-content: center;
    align-items: center;
    font-size: 90%;
    cursor: pointer;
    min-width: 80px;
    height: 50px;
    border: solid 1px #2b4463;
    border-radius: 5px;
    object-fit: cover;
    padding: 9px;
  }

  .file-upload-container {
    text-align: center;
    vertical-align: middle;
    width: 150px;
  }

</style>